import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';

import { AddNewCompanyComponent } from '../components/add-new-company/add-new-company.component';
import { ListCompaniesComponent } from '../components/list-companies/list-companies.component';
import { CompaniesRoutingModule } from './companies-routing.module';
import { CompaniesComponent } from './companies.component';
import { EditCompanyComponent } from '../edit-company/edit-company.component';

import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { EditCompanyModule } from '../edit-company/edit-company.module';

const components = [CompaniesComponent, ListCompaniesComponent, AddNewCompanyComponent];

@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    CompaniesRoutingModule,
    SharedModule,
    MatIconModule,
    EditCompanyModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatInputModule,
    MatMenuModule
  ],
  declarations: [...components]
})
export class CompaniesModule { }
